/**
 * Add class to section-padding if it contains only empty elements
 */
(function() {
  function checkEmptySections() {
    const sections = document.querySelectorAll('.section-spacing');
    
    sections.forEach(section => {
      // Check if section is empty or contains only whitespace/empty elements
      const isEmpty = !section.textContent.trim() || 
                      (section.children.length === 0) ||
                      (Array.from(section.children).every(child => !child.textContent.trim()));
      
      if (isEmpty) {
        section.classList.add('section-empty');
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkEmptySections);
  } else {
    checkEmptySections();
  }
})();